import React, { useState } from "react";
import {
  Avatar,
  Typography,
  Container,
  Paper,
  Grid,
  InputLabel,
} from "@mui/material";
import { useDispatch } from "react-redux";
import { forgotPass } from "store/actions/auth";
import { useHistory, Link } from "react-router-dom";
import { useFormik } from "formik";
import * as yup from "yup";

import Button from "components/Shared/CustomButtons/Button.js";
import Input from "components/Shared/CustomInput/Input";
import useClasses from "hooks/useClasses";

import styles from "./styles";

const validationSchema = yup.object({
  email: yup
    .string("Enter your email")
    .email("Enter a valid email")
    .required("Email is required"),
});

const ForgotPass = () => {
  const formik = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      handleSubmit(values);
    },
  });
  const classes = useClasses(styles);
  const dispatch = useDispatch();
  const history = useHistory();

  const handleSubmit = (values) => {
    dispatch(forgotPass(values, history));
  };

  return (
    <div className={classes.main}>
      <Container component="main" maxWidth="xs">
        <Paper className={classes.paper} elevation={3}>
          <div className={classes.header}>
            <Typography className={classes.title} variant="h4">
              Forgot Password
            </Typography>
          </div>
          <form className={classes.form} onSubmit={formik.handleSubmit}>
            <Grid container spacing={2}>
              <InputLabel style={{ fontWeight: "bold", marginLeft: "10px" }}>
                Email:
              </InputLabel>
              <Input
                id="email"
                name="email"
                label="Email address"
                value={formik.values.email}
                onChange={formik.handleChange}
                error={formik.touched.email && Boolean(formik.errors.email)}
                helperText={formik.touched.email && formik.errors.email}
                type="email"
              />
            </Grid>
            <Button
              color="primary"
              fullWidth
              variant="contained"
              className={classes.submit}
              type="submit"
            >
              send
            </Button>
            <Grid container justifyContent="space-between" alignItems="center">
              <Grid item>
                <span>
                  <strong>Contact support: </strong>
                  <a
                    href="tel:+201287158065"
                    target="_blank"
                    rel="noopener"
                    style={{ color: "inherit", textDecoration: "none" }}
                  >
                    +201287158065
                  </a>
                </span>
              </Grid>
              <Grid item>
                <Button component={Link} to="/login" color="transparent">
                  Already have an account? Log In
                </Button>
              </Grid>
            </Grid>
          </form>
        </Paper>
      </Container>
    </div>
  );
};

export default ForgotPass;
